import { render, staticRenderFns } from "./SummaryPerVesselManningGraphContainer.vue?vue&type=template&id=88b5fd3e&scoped=true&"
import script from "./SummaryPerVesselManningGraphContainer.vue?vue&type=script&lang=js&"
export * from "./SummaryPerVesselManningGraphContainer.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPerVesselManningGraphContainer.vue?vue&type=style&index=0&id=88b5fd3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b5fd3e",
  null
  
)

export default component.exports